import { NON_CALLABLE_HOOKS } from "../Hooks";
import { applyQueries } from "../Helpers";
// set is a reserved word in the language
export function setter(connectionName, store, t, p, v // Proxy auto-passed params
) {
    if (p === NON_CALLABLE_HOOKS.query) {
        t[p] = v;
        applyQueries(store, connectionName, t);
        return true;
    }
    return Reflect.set(t, p, v);
}
//# sourceMappingURL=setter.js.map